import React from 'react';

import { Header, LoginForm } from 'components';
import { PublicRoute } from 'utils';

export const Login = () => {
  PublicRoute();

  return (
    <>
      <Header />
      <LoginForm />
    </>
  );
};
